export default __webpack_public_path__ + "static/media/braceletsCatrinel.7a247306.webp";